import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteLocationOverrideRulesByFilter } from '../../../api/plan-location-override-rules-api'
import type {
  DeleteLocationOverrideRulesByFilterRequestDto,
  DeleteLocationOverrideRulesByFilterResponseDto,
} from '../../../api/dto/plan-location-override-rules.dto'
import { LOCATION_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanLocationOverride/hooks/useGetLocationOverrideRules'

export function useDeleteLocationOverrideRulesByFilter() {
  const queryClient = useQueryClient()

  return useMutation<
    DeleteLocationOverrideRulesByFilterResponseDto,
    unknown,
    DeleteLocationOverrideRulesByFilterRequestDto
  >({
    mutationFn: (params) => deleteLocationOverrideRulesByFilter(params),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [LOCATION_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
